import { Controller } from "@hotwired/stimulus"

// Controller für JSON-Uploads (Backend)
// - Validiert Dateityp (.json)
// - Validiert Dateigröße anhand data-max-size-mb (Fallback 10 MB)
// - Optional: Grobe JSON-Validierung durch Parsen
export default class extends Controller {
  static targets = ["input", "error"]

  connect() {
    this.bind()
  }

  bind() {
    const input = this.inputTarget
    if (!input) return
    input.addEventListener('change', (event) => {
      this.validateFile(event.target.files[0])
    })
  }

  validateFile(file) {
    if (!file) {
      this.hideError()
      return true
    }

    const maxSizeMb = parseInt(this.inputTarget?.dataset?.maxSizeMb || '10', 10)
    const maxSize = maxSizeMb * 1024 * 1024

    // Typprüfung: JSON
    const isJson = file.type === 'application/json' || file.name.toLowerCase().endsWith('.json')
    if (!isJson) {
      this.showError('Bitte wählen Sie eine JSON-Datei aus.')
      return false
    }

    // Größenprüfung
    if (file.size > maxSize) {
      this.showError(`Die Datei ist zu groß. Maximale Größe: ${maxSizeMb} MB`)
      return false
    }

    // Optional: Inhalt grob validieren
    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        JSON.parse(e.target.result)
        this.hideError()
      } catch (e) {
        this.showError(`Ungültige JSON-Datei: ${e.message}`)
      }
    }
    reader.readAsText(file)
    return true
  }

  showError(message) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove('hidden')
  }

  hideError() {
    if (!this.hasErrorTarget) return
    this.errorTarget.classList.add('hidden')
  }
}


